import { UserAgreementState } from './types'

export const state: UserAgreementState = {
  currentUserAgreements: [],
  acceptedUserAgreements: [],
}